module.exports = __webpack_public_path__ + "static/media/account-cover.e682358e.jpg";